import moment from "moment";
import { of, from, Observable } from "rxjs";
import { store } from "..";
import { API } from "../../services/http";
import { processErrorFromPromise } from "../errors/utils";
import { FetchableError, FetchableSuccess } from "./fetchable/helpers";

export function generateDownload<T>(
  api: API,
  link: string,
  options?: {
    query?: object;
    headers?: object;
    verb: "get" | "post";
    fileName?: string;
    data?: object;
  }
): () => Observable<FetchableSuccess<T> | FetchableError> {
  return () => {
    const login = store.getState().auth.login;
    if (login.status !== "ready")
      return of({
        status: "error",
        err: new Error("User not logged in"),
      });

    return from(
      (options?.verb === "get" ? api.get(link) : api.post(link))
        .send(options?.data ?? {})
        .set(options?.headers || {})
        .query(options?.query || {})
        .responseType("blob")
        .then<FetchableSuccess<T>>(({ body }) => {
          var a = document.createElement("a");
          a.href = window.URL.createObjectURL(body);
          a.download =
            options?.fileName ||
            `entries_${moment().format("YYYY-MM-DD_HH-mm-ss")}.csv`;
          a.click();
          return { status: "ready", data: body };
        })
        .catch<FetchableError>(processErrorFromPromise)
        .catch<FetchableError>((err: Error) => ({
          status: "error",
          err,
        }))
    );
  };
}
